import { LogLevel } from '@azure/msal-browser';

const sign_in_policy = "b2c_1_login";
const forgot_password_policy = "b2c_1_reset";
const edit_profile_policy = "b2c_1_edit_profile";

const azure_domain = import.meta.env.VITE_AZUREAD_DOMAIN;
const azure_url = import.meta.env.VITE_AZUREAD_URL;
const azure_client_id = import.meta.env.VITE_AZUREAD_CLIENTID;
const redirect_uri = import.meta.env.VITE_APP_REDIRECT_URI;

const b2cPolicies = {
  names: {
    signUpSignIn: sign_in_policy,
    forgotPassword: forgot_password_policy,
    editProfile: edit_profile_policy
  },
  authorities: {
    signUpSignIn: {
      authority: `${azure_url}${sign_in_policy}`
    },
    forgotPassword: {
      authority: `${azure_url}${forgot_password_policy}`
    },
    editProfile: {
      authority: `${azure_url}${edit_profile_policy}`
    }
  },
  authorityDomain: azure_domain
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
const msalConfig = {
  auth: {
    clientId: azure_client_id, // This is the ONLY mandatory field that you need to supply.
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Use a sign-up/sign-in user-flow as a default authority
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: redirect_uri, // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
    postLogoutRedirectUri: `${azure_url}${sign_in_policy}/oauth2/v2.0/logout?post_logout_redirect_uri=${redirect_uri}`, // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    iframeHashTimeout: 10000,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            return;
          case LogLevel.Info:
            return;
          case LogLevel.Verbose:
            return;
          case LogLevel.Warning:
            return;
        }
      }
    }
  }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
const loginRequest = {
  scopes: [azure_client_id]
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
const silentRequest = {
  scopes: ["user.read"]
};

export { b2cPolicies, msalConfig, loginRequest, silentRequest };